import React from 'react';

import PropTypes from 'prop-types';
import { faPlus } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';

const NewButton = ({ onClick }) => (
  <Button onClick={onClick}>
    <FontAwesomeIcon icon={faPlus} />
    New Decedent
  </Button>
);

NewButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default NewButton;
